var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 107,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.98 106.3H11.62C5.313 106.3.2 101.187.2 94.88V52.565c0-1.242.51-2.43 1.412-3.284L50.553 2.89a10.533 10.533 0 0 1 14.494 0l46.663 44.233a11.826 11.826 0 0 1 3.69 8.582V94.88a11.42 11.42 0 0 1-11.42 11.42z",
    fill: "#DE3530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.2 53.26h114.24v46.144a6.896 6.896 0 0 1-6.896 6.896H7.096A6.896 6.896 0 0 1 .2 99.404V53.26z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C4C656",
    x: 15.2,
    y: 16.9,
    width: 84.96,
    height: 84.96,
    rx: 6.283
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    d: "M100.16 55.168v46.692H15.2V55.168L57.68 75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.68 78.34 3.25 52.032A2.208 2.208 0 0 0 .08 54.02v45.264a6.896 6.896 0 0 0 6.896 6.896h101.408a6.896 6.896 0 0 0 6.896-6.896V54.795a2.695 2.695 0 0 0-3.868-2.426L57.68 78.339z",
    fill: "#DE3530"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M22.52 24.7h23.76v3.36H22.52zM20.6 36.94h70.56v1.92H20.6zM20.6 43.42h70.56v1.92H20.6zM20.6 49.9h70.56v1.92H20.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 18.68,
    cy: 18.238,
    rx: 9.84,
    ry: 9.858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4C11.268 4 5 10.268 5 18s6.268 14 14 14 14-6.268 14-14c-.023-7.723-6.277-13.977-14-14zm-2.862 22L9 18.79l2.002-2.021 5.142 5.194L26.998 11 29 13.022 16.138 26z",
    fill: "#57B894"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.f905a2e1c09caeec15e3c1db28190d45.svg";
export { ForwardRef as ReactComponent };